import styled from "styled-components/macro";

import { Row } from "components/Layout";
import { BoldText, Text } from "components/Text";

export const ReviewCard = styled.div`
  padding: 12px 16px;
  margin-bottom: 12px;
  background: #fff;
`;

export const ReviewCardTitle = styled(BoldText)`
  display: block;
  font-size: 16px;
  letter-spacing: 0.05em;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 8px;
`;

export const ReviewFieldGrid = styled(Row).attrs({ flexWrap: true })`
  gap: 6px 16px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ReviewFieldLabel = styled(Text)`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 2px;
`;
